module.exports = __webpack_public_path__ + "static/img/xueyuan_bg.503bb2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/researchCamp/xueyuan_bg.png
// module id = YgVF
// module chunks = 1